import { render, staticRenderFns } from "./Platin360Kategori.vue?vue&type=template&id=7637be3b&scoped=true"
import script from "./Platin360Kategori.vue?vue&type=script&lang=js"
export * from "./Platin360Kategori.vue?vue&type=script&lang=js"
import style0 from "./Platin360Kategori.vue?vue&type=style&index=0&id=7637be3b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7637be3b",
  null
  
)

export default component.exports